import { StoryblokRichtext, render } from 'storyblok-rich-text-react-renderer';
import GalleryImage from './base/GalleryImage'
import GalleryVideo from './base/GalleryVideo'
import imageSixBars from '../assets/images/bars-six.svg';
import { VideoGallery } from './modules/VideoGallery';

type ProjectDetailsProps = {
  blok: {
    title?: string;
    subtitle?: string;
    skills?: StoryblokRichtext;
    content?: StoryblokRichtext;
    image?: {
      alt?: string;
      filename?: string;
    };
    video?: {
      filename?: string;
    };
    gallery?: {
      component: string;
      isTwoColumn?: boolean;
      image?: {
        alt?: string;
        filename?: string;
      };
      video?: {
        filename?: string;
      };
      _editable: string;
      _uid: string;
      video_gallery_items?: {}[];
    }[];
  };
}

const ProjectDetails = ({ blok }: ProjectDetailsProps) => {
  const style: React.CSSProperties = {
    backgroundImage: `url(${imageSixBars})`,
    backgroundSize: 'auto',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };

  return (
    <section className='projectDetails mb-[114px]' style={style}>
      <div className='relative'>
        {blok?.image?.filename && (
          <div className='w-full h-auto overflow-hidden mt-14'>
            <GalleryImage fileName={blok.image?.filename} alt={''} />
          </div>
        )}
        {blok?.video?.filename && (
          <div className='w-full h-auto overflow-hidden mt-14'>
            <GalleryVideo fileName={blok.video?.filename} />
          </div>
        )}
      </div>
      <div className='container mx-auto flex flex-col px-5'>
        <h1 className='style-10-mobile text-center phone:style-10 phone:text-center mt-[105px] mb-8 uppercase'>
          {blok?.title}
        </h1>
        <h2 className='style-12-mobile font-respira text-center mb-8'>
          {blok?.subtitle}
        </h2>
        <div className='flex flex-col tablet:flex-row gap-[29px] tablet:ml-[120px] mb-8 mt-12 text-left prose'>
          {blok?.skills && (
            <div className='phone:min-w-[175px] tablet:w-[188px]'>
              <h3 className='uppercase style-14-mobile tablet:style-14 !font-bold'>
                Skills
              </h3>
              <div className='style-1-mobile tablet:style-1'>
                {render(blok.skills)}
              </div>
            </div>
          )}
          {blok?.content && (
            <div className='style-1-mobile tablet:style-1 max-w-[550px] text-left'>
              {render(blok.content)}
            </div>
          )}
        </div>
      </div>
      <div className='w-full'>
        {blok?.gallery?.map((item) => (
          <div key={item._uid}>
            {item.video_gallery_items && (
              <VideoGallery items={item.video_gallery_items} />
            )}
            {item.image?.filename && (
              <GalleryImage fileName={item.image.filename} isTwoColumn={item.isTwoColumn} alt={item.image.alt ?? 'Aliens Exist Gallery Image'} />
            )}
            {item.video?.filename && (
              <GalleryVideo fileName={item.video.filename} isTwoColumn={item.isTwoColumn} />
            )}

            {item.isTwoColumn && (<span className='clear-both content-none'></span>)}
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProjectDetails;
